'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _Styles = require('../utils/Styles');

var _UIIcon = require('./UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _IconConstants = require('./IconConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Outer = _styledComponents2.default.span.withConfig({
  displayName: 'UIIconHolder__Outer'
})(['display:inline-flex;line-height:1;user-select:none;position:relative;background-color:', ';border-color:', ';border-radius:', ';border-style:', ';border-width:', ';font-size:', ';padding:', ';transform:', ';vertical-align:', ';&.private-icon-circle--legacy{display:inline-flex;align-items:center;height:2em;justify-content:center;width:2em;}'], function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, function (_ref2) {
  var borderColor = _ref2.borderColor;
  return borderColor;
}, function (_ref3) {
  var borderRadius = _ref3.borderRadius;
  return borderRadius;
}, function (_ref4) {
  var borderStyle = _ref4.borderStyle;
  return borderStyle;
}, function (_ref5) {
  var borderWidth = _ref5.borderWidth;
  return (0, _Styles.toPx)(borderWidth);
}, function (_ref6) {
  var size = _ref6.size;
  return size != null && (_IconConstants.ICON_SIZES[size] || size) + 'px';
}, function (_ref7) {
  var padding = _ref7.padding;
  return padding != null && padding + 'em';
}, function (_ref8) {
  var rotate = _ref8.rotate;
  return rotate != null && 'rotate(' + rotate + 'deg)';
}, function (_ref9) {
  var verticalAlign = _ref9.verticalAlign;
  return verticalAlign;
});

var getIconTransform = function getIconTransform(_ref10) {
  var rotate = _ref10.rotate,
      rotateLock = _ref10.rotateLock;
  return rotate != null && !rotateLock ? 'rotate(' + rotate * -1 + 'deg)' : null;
};

var Icon = (0, _styledComponents2.default)(function (props) {
  var __rotate = props.rotate,
      __rotateLock = props.rotateLock,
      rest = _objectWithoutProperties(props, ['rotate', 'rotateLock']);

  return _react2.default.createElement(_UIIcon2.default, rest);
}).withConfig({
  displayName: 'UIIconHolder__Icon'
})(['height:1em;width:1em;margin:0.25em 0.125em 0;transform-origin:50% 38%;transform:', ' translateY(-6.3%);'], getIconTransform);

var UIIconHolder = function (_PureComponent) {
  _inherits(UIIconHolder, _PureComponent);

  function UIIconHolder() {
    _classCallCheck(this, UIIconHolder);

    return _possibleConstructorReturn(this, (UIIconHolder.__proto__ || Object.getPrototypeOf(UIIconHolder)).apply(this, arguments));
  }

  _createClass(UIIconHolder, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _fromUIIconCircle = _props._fromUIIconCircle,
          borderRadius = _props.borderRadius,
          color = _props.color,
          innerClassName = _props.innerClassName,
          innerStyles = _props.innerStyles,
          name = _props.name,
          rotate = _props.rotate,
          rotateLock = _props.rotateLock,
          size = _props.size,
          rest = _objectWithoutProperties(_props, ['_fromUIIconCircle', 'borderRadius', 'color', 'innerClassName', 'innerStyles', 'name', 'rotate', 'rotateLock', 'size']);

      if (borderRadius === '50%' && !_fromUIIconCircle) {
        _devLogger2.default.warn({
          message: 'UIIconHolder: Instead of using borderRadius="50%", use a UIIconCircle.',
          key: 'UIIconHolder-circle'
        });
      }

      return _react2.default.createElement(
        Outer,
        _extends({}, rest, { borderRadius: borderRadius, rotate: rotate, size: size }),
        _react2.default.createElement(Icon, {
          className: innerClassName,
          color: color,
          name: name,
          rotate: rotate,
          rotateLock: rotateLock,
          size: size,
          style: innerStyles
        })
      );
    }
  }]);

  return UIIconHolder;
}(_react.PureComponent);

exports.default = UIIconHolder;


UIIconHolder.propTypes = {
  _fromUIIconCircle: _react.PropTypes.bool,
  backgroundColor: _react.PropTypes.string,
  borderColor: _react.PropTypes.string,
  borderRadius: _react.PropTypes.string,
  borderStyle: _react.PropTypes.oneOf(['solid', 'double', 'dashed', 'dotted', 'initial', 'inherit', 'unset']),
  borderWidth: _react.PropTypes.number,
  verticalAlign: _react.PropTypes.string,
  classname: _react.PropTypes.string,
  color: _UIIcon2.default.propTypes.color,
  innerClassName: _react.PropTypes.string,
  name: _UIIcon2.default.propTypes.name,
  padding: _react.PropTypes.number,
  rotate: _react.PropTypes.number,
  rotateLock: _react.PropTypes.bool,
  size: _UIIcon2.default.propTypes.size,
  innerStyles: _react.PropTypes.object
};

UIIconHolder.defaultProps = {
  padding: 0.5,
  rotate: 0,
  borderStyle: 'solid',
  borderWidth: 0
};

UIIconHolder.displayName = 'UIIconHolder';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/icon/UIIconHolder.js
// module id = 113
// module chunks = 171